/* eslint-disable @typescript-eslint/naming-convention */
import { CanDeactivateFn } from '@angular/router';
import { ROUTER_PATHS } from '../../app.const';

export const secureCheckoutNavigationGuard: CanDeactivateFn<unknown> = (
  _component,
  _currentRoute,
  currentState,
  nextState
) => {
  const nextRouteName = nextState?.url;
  const currentRouteName = currentState?.url.toLowerCase();

  if (nextRouteName.includes(ROUTER_PATHS.SECURE_CHECKOUT)) {
    return currentRouteName.includes(ROUTER_PATHS.TRAVELER_DETAILS) || currentRouteName.includes('quoteid');
  }
  return true;
};
